import React, {useState} from "react";
import {Input} from "antd";
import {NavLink, useLocation} from "react-router-dom";
import {ROUTES as ROUTES_CONFIG} from "../../../config/constants";
import {selectUser} from "../../../redux/features/userSlice";
import {useDispatch, useSelector} from "react-redux";
import { redirectTo } from "../../../config/CoreMethods";

const selector = useSelector;

const EventsFilter = () => {

    let GetUser = selector(selectUser);

    const filterNav = [
        {id: 1, name: 'Past Events', path: 'past-events'},
        {id: 2, name: 'My Events', path: 'my-events'},
        {id: 3, name: 'My Tickets', path: 'my-tickets'},
    ]

    const [eventSearch, setEventSearch] = useState('');

    const location = useLocation();

    const setSearchText = (value) => {
        SettingSearchText(value)
    }

    let Timeout;

    const SettingSearchText = (value) => {

        clearTimeout(Timeout)

        Timeout = setTimeout(function() {
            setEventSearch(value)
        }, 500);
    }

    return (
        <div className="font-mont events-filter">
            <div className="events-action">
                <Input size="large" placeholder="Search for an event" className="input input-search"
                       prefix={<i className="icon-search text-gray-300"></i>}
                       onChange={e => setSearchText(e.target.value)}
                       defaultValue={eventSearch}
                />
                <div className="events-nav">
                    {filterNav.map((item, id) => { 
                        return <NavLink
                            to={`/${item.path}`} key={item.id}
                            className={`${location.pathname == item.path ? 'active' : ''}`}>
                            <span>{item.name}</span>
                        </NavLink>
                    })}
                </div>
            </div>
            <NavLink onClick={ () => redirectTo(GetUser && GetUser.id ? ROUTES_CONFIG.eventsStep.path : ROUTES_CONFIG.loginPage.path) } className="events-submit">
                <i className="icon-zoom-in"></i>
                <span>Submit Event</span>
            </NavLink>
        </div>
    )
}

export default EventsFilter;